"use client";

import { MyButton } from "@/components/atoms";
import styles from "./styles.module.scss";
import { FC } from "react";
import classNames from "classnames";
import { usePathname } from "next/navigation";

export interface ContactezNousProps {
  className?: string;
}

export const ContactezNous: FC<ContactezNousProps> = ({ className }) => {
  const pathname = usePathname();

  return (
    <>
      {pathname !== "/contact" && (
        <div className={classNames(styles.contactez_nous, className)}>
          <div className={styles.block}>
            <div className={styles.contents}>
              <h2>Une Envie, un projet ?</h2>
              <p>
                Vous rêvez d&apos;un aménagement extérieur ou de créer un jardin
                unique ?
                <br />
                Discutons ensemble de vos idées et donnons-leur vie.
              </p>

              <div className={styles.btn_contactez_nous}>
                <MyButton to="/contact" label="Prendre rendez-vous" />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
